import { Skeleton } from "@mui/material";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import { capitalizeFirstLetter, excerpt } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import HeaderSearch from "@unisearch/theme/layout/headers/header_search";
import Link from "next/link";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import styles from "./content.module.scss";

const SearchContnet = () => {
  const router = useRouter();
  const { query } = router;
  const [result, setResult] = useState([]);
  const [popular, setPopular] = useState([]);
  const [paginate, setPaginate] = useState({});
  const [page, setPage] = useState(query.page || 1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await API.get(
          `/search/common?searchString=${query.key}&limit=10&page=${page}`
        );
        if (res.data) {
          const { currentPage, limit, page_total, total, results } = res.data;
          setPaginate({ currentPage, limit, page_total, total });
          setResult(results);
        }
        setLoading(false);
        router.push(`/search-common?key=${query.key}&page=${page}`, undefined, {
          shallow: true,
        });
      } catch (error) {
        setLoading(false);
      }
    };

    if (query.key) {
      fetchData();
    }
  }, [query.key, page]);

  // fetch popular searches
  useEffect(() => {
    const fetchPopularData = async () => {
      try {
        const res = await API.get(`/search/common?searchString=a&limit=4`);
        if (res.data) {
          const { results } = res.data;
          setPopular(results);
        }
      } catch (error) {}
    };
    fetchPopularData();
  }, []);

  //Pagination Handler
  const paginationHandler = (event, page) => {
    setPage(page);
  };

  const style = {
    blog: {
      backgroundColor: "rgba(0, 145, 255, 0.1)",
      color: "rgb(0, 145, 255)",
    },
    pages: {
      backgroundColor: "rgba(74, 200, 166, 0.1)",
      color: "rgb(74, 200, 166)",
    },
    news: {
      backgroundColor: "rgba(93, 95, 239, 0.1)",
      color: "rgb(93, 95, 239)",
    },
  };

  return (
    <Fragment>
      <section className={styles.section_search_hero}>
        <div className="container">
          {loading ? (
            <>
              <div
                style={{
                  maxWidth: 300,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <Skeleton animation="wave" height={40} />
                <Skeleton animation="wave" height={40} />
              </div>
            </>
          ) : (
            <Fragment>
              {result && result?.length > 0 ? (
                <div className={styles.hero_content_wrapper}>
                  <div className={styles.search_result_text}>
                    {paginate?.total} results found for <br />
                    <span>{query?.key}</span>
                  </div>
                </div>
              ) : (
                <div className={styles.noresult_text_wrapper}>
                  <div className={styles.soft_bg}></div>
                  <h1 className={styles.noresult_title}>
                    We did not find any results for <br />
                    {query?.key}
                  </h1>
                  <p className={styles.noresult_sub_text}>
                    Click here to begin your search again.
                  </p>

                  <HeaderSearch showBig={true} placeholder="Search" />
                  {/* <button
                    type="button"
                    onClick={() => router.push("/")}
                    className={`btn btn-secondary btn-bg ${styles.noresult_btn}`}
                  >
                    <FiArrowLeft style={{ fontSize: "18px" }} /> Back to Home
                  </button> */}
                </div>
              )}
            </Fragment>
          )}
        </div>
      </section>

      {result && result?.length > 0 && (
        <section className={styles.section_search_result}>
          <div className="container">
            <div className={styles.wrapper}>
              {/* left side */}
              <div className={styles.left_side}>
                <div className={styles.result_wrapper}>
                  {loading ? (
                    <Fragment>
                      {new Array(8).fill(1).map((_, i) => {
                        return (
                          <div key={i}>
                            <Skeleton
                              variant="rectangular"
                              animation="wave"
                              height={30}
                              sx={{ marginBottom: "8px" }}
                            />
                            <Skeleton
                              variant="rectangular"
                              animation="wave"
                              height={60}
                              sx={{ marginBottom: "8px" }}
                            />
                          </div>
                        );
                      })}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {result &&
                        result?.length > 0 &&
                        result?.map((item, i) => {
                          return (
                            <div className={`${styles.result_card}`} key={i}>
                              <div
                                className={styles.badge}
                                style={style[item?.sourceType]}
                              >
                                {capitalizeFirstLetter(item?.sourceType)}
                              </div>

                              <Link href={`/${item?.sourceLink}`}>
                                <h4
                                  className={`line-clamp-1 ${styles.card_title}`}
                                >
                                  {item?.title}
                                </h4>
                              </Link>
                              <div
                                className={`line-clamp-2 ${styles.card_description}`}
                              >
                                {item?.shortDescription
                                  ? excerpt(item?.shortDescription, 400)
                                  : item?.content
                                  ? excerpt(item?.content, 400)
                                  : ""}
                              </div>
                            </div>
                          );
                        })}
                    </Fragment>
                  )}
                </div>

                <div className={styles.paginate_wrapper}>
                  <PaginationComponent
                    paginate={paginate}
                    paginationHandler={paginationHandler}
                  />
                </div>
              </div>

              {/* right side */}
              <div>
                {loading ? (
                  <Fragment>
                    {new Array(4).fill(1).map((_, i) => {
                      return (
                        <div key={`popular${i}`}>
                          <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={30}
                            sx={{ marginBottom: "8px" }}
                          />
                          <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={60}
                            sx={{ marginBottom: "8px" }}
                          />
                        </div>
                      );
                    })}
                  </Fragment>
                ) : (
                  <Fragment>
                    <h4 className={styles.suggestion_heading}>
                      Popular Searches
                    </h4>
                    <div className={styles.suggestioin_card_wrapper}>
                      {popular &&
                        popular?.length > 0 &&
                        popular?.map((pitem, i) => {
                          return (
                            <div
                              className={`${styles.suggestion_card}`}
                              key={`pitem${i}`}
                            >
                              <div
                                className={styles.badge}
                                style={style[pitem?.sourceType]}
                              >
                                {capitalizeFirstLetter(pitem?.sourceType)}
                              </div>

                              <Link href={`/${pitem?.sourceLink}`}>
                                <h4
                                  className={`line-clamp-1 ${styles.suggestion_card_title}`}
                                >
                                  {pitem?.title}
                                </h4>
                              </Link>

                              <div
                                className={`line-clamp-2 ${styles.suggestion_card_description}`}
                              >
                                {pitem?.shortDescription
                                  ? excerpt(pitem?.shortDescription, 400)
                                  : pitem?.content
                                  ? excerpt(pitem?.content, 400)
                                  : ""}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default SearchContnet;
